import { EvaluationStatus } from "../../common/components/questionnaireComponents/evaluateQuestionnaireDialog/EvaluateQuestionnaireDialog.types";
import { SelectableItem } from "../../processingActivity/ProcessingActivity.types";
import { BaseViewModel } from "../../system/systemOverview/SystemOverview.types";
import { IDownloadLegalEntityClassificationReport } from "./DownloadLegalEntityClassificationReport.hooks.ts";

export interface LegalEntityClassificationApiModel {
    rows: Array<LegalEntityClassificationApiRow>;
    selectableSystems: Array<SelectableItem>;
    selectableLegalEntities: Array<SelectableItem>;
}

export interface LegalEntityClassificationApiRow {
    id: string;
    created: Date;
    questionnaireId: string;
    questionnaireName: string;
    questionnaireResponseId: string;
    system?: BaseViewModel;
    processingActivity?: BaseViewModel;
    legalEntity: AssignedLegalEntity;
    riskLevel?: RiskLevel;
    score?: number;
    riskName?: string;
    submitted?: Date;
    submittedBy?: string;
    note?: string;
    report?: string;
    scoreEnabled: boolean;
    hasRecommendations: boolean;
    evaluationStatus?: EvaluationStatus;
    evaluation: string;
    permissions: {
        read: boolean;
        create: boolean;
        edit: boolean;
        delete: boolean;
    };
    partOfCurrentPlan: boolean;
}

export interface LegalEntityClassificationViewRow extends LegalEntityClassificationApiRow {
    scoreName?: string;
    evaluationName?: string;
    legalEntityName: string;
    createdString: string;
    submittedString: string;
    relatedEntityName?: string;
    notePlainText: string;
}

export interface AssignedLegalEntity {
    name: string;
    legalEntityId: string;
    isGroupEntity: boolean;
}

export enum RiskLevel {
    None = 0,
    VeryLow = 1,
    Low = 2,
    Medium = 3,
    High = 4,
    VeryHigh = 5,
}
